import React, { useEffect, useState } from "react"
import { Checkbox, Stack, Typography } from "@mui/material"

const CookingDelayCheckbox = ({ isAllTreated = false }) => {
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    setChecked(isAllTreated)
  }, [isAllTreated])

  const handleCheckedChange = (event) => {
    setChecked(event.target.checked)
  }

  return (
    <Stack direction="row" spacing={1.33} alignItems="center">
        <Typography>
            Traité
        </Typography>
        <Checkbox checked={checked} color="primary" onChange={handleCheckedChange}/>
    </Stack>
  )
}

export default CookingDelayCheckbox